webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2x06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("cX0o");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-feed',
  resource: 'BlogFeed',

  props: {
    filters: {
      type: Object,
      default: function _default() {}
    },
    feed: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    begin: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    website: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {
      transition: 'preview-appear'
    };
  },


  computed: {
    reading: function reading() {
      return this.filters.post;
    },
    scrollDelay: function scrollDelay() {
      return this.$device.phone ? 0 : 560;
    },
    figureClass: function figureClass() {
      return { 'preview__figure--mobile': this.$device.phone && this.reading };
    },
    feed_filter: function feed_filter() {
      var _this = this;

      // const filterBy = {
      //   post: (filter, { id }) => filter === id,
      //   author: (filter, { gender }) => {
      //     return filter === gender;
      //   },
      //   search: (filter, { title }) => {
      //     return this.kebabify(title).includes(filter);
      //   }
      // }
      // if (!Object.keys(this.filters).length) return this.feed

      // return this.feed.filter(post => {
      //   return Object.keys(this.filters).every(filter => {
      //     return filterBy[filter](this.filters[filter], post)
      //   })
      // })
      var filterBy = {
        post: function post(filter, _ref) {
          var slug = _ref.slug;
          return filter === slug;
        }
      };
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).length) return this.feed;
      return this.feed.filter(function (post) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.filters).every(function (filter) {
          if (typeof filterBy[filter] !== 'undefined') {
            return filterBy[filter](_this.filters[filter], post);
          } else {
            return _this.feed;
          }
        });
      });
    }
  },
  updated: function updated() {
    // this.$emit('loadfeed');
  },

  methods: {
    scrollTo: __WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* scrollTo */],
    kebabify: __WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* kebabify */],
    prettyDate: __WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* prettyDate */],
    getBgImg: function getBgImg(src) {
      if (src !== '') {
        if (src.includes('http://') || src.includes('https://')) {
          return { backgroundImage: 'url(' + src + ')' };
        }
        var arrSrc = src.split(';');
        return { backgroundImage: 'url(' + (this.website + '/image/' + arrSrc[0]) + ')' };
      }
      // retrurn default nophoto
      return { backgroundImage: 'url(' + src + ')' };
    },
    stackPosts: function stackPosts(posts) {
      var _this2 = this;

      var interval = void 0;
      var stack = function stack() {
        _this2.posts.push(posts.shift());

        if (!posts.length) {
          _this2.transition = 'preview';
          clearInterval(interval);
        }
      };

      interval = setInterval(stack, 125);
    },

    setbegin: function setbegin() {
      this.$emit('setBegin', 1);
    }
  },

  mounted: function mounted() {
    // this.$getResource('feed')
    //   .then(posts => {
    //     if (!Object.keys(this.filters).length) {
    //       this.stackPosts(posts)
    //     } else {
    //       this.posts = posts
    //       this.transition = 'preview'
    //     }
    //   })
    this.$nextTick(function () {
      this.feed = this.$props.feed;
      this.website = this.$props.website;
      this.transition = 'preview';
    });
  }
});

/***/ }),

/***/ "6Lyb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-footer',
  props: {
    destinationpoints: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filters: {
      type: Object,
      default: function _default() {}
    }
  },
  // asyncComputed: {
  //   async destinationpoints() {
  //     let url = `http://haidangtravel.com/api/destinationpoint`;
  //     const res = axios.post(url).then(function(response) {
  //       // this.destinationpoints = response.data;
  //       this.dpReady = true;
  //       this.componentKey += 1;
  //     });
  //     console.log(res);
  //     return res.data;
  //   }
  // },
  computed: {
    reading: function reading() {
      return this.filters.post;
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "9k9s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Blog__ = __webpack_require__("eJ85");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Blog", function() { return __WEBPACK_IMPORTED_MODULE_0__Blog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogFeed__ = __webpack_require__("bksL");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BlogFeed", function() { return __WEBPACK_IMPORTED_MODULE_1__BlogFeed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BlogPost__ = __webpack_require__("rcwA");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BlogPost", function() { return __WEBPACK_IMPORTED_MODULE_2__BlogPost__["a"]; });




/***/ }),

/***/ "CHQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BlogNav__ = __webpack_require__("y7Eb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogFeed__ = __webpack_require__("xdpD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BlogPost__ = __webpack_require__("InHs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BlogFooter__ = __webpack_require__("kYEd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__("cX0o");
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog',
  components: { BlogNav: __WEBPACK_IMPORTED_MODULE_0__BlogNav__["a" /* default */], BlogFeed: __WEBPACK_IMPORTED_MODULE_1__BlogFeed__["a" /* default */], BlogPost: __WEBPACK_IMPORTED_MODULE_2__BlogPost__["a" /* default */], BlogFooter: __WEBPACK_IMPORTED_MODULE_3__BlogFooter__["a" /* default */] },
  resource: 'Blog',
  props: {
    post: String,
    author: String,
    search: String,
    slug: String,
    category: String
  },
  methods: {
    loadFeed: function loadFeed(ele) {
      var _this = this;

      var total = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;

      console.log(this.lastestResult);
      if (this.lastestResult >= 6) {
        var slug = this.slug || '';
        var category = this.category || '';
        var url = 'http://haidangtravel.com/api/blog' + (slug !== '' ? '/' + slug : '');
        if (this.$route.name === 'category') {
          url = 'http://haidangtravel.com/api/blog/category/' + category;
        }
        if (this.feed.length === 1 && slug === '') {
          this.clearFeed();
        }
        if (!(ele !== null && slug !== '')) {
          __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* axios */].post(url, {
            begin: this.feed.length,
            take: total,
            slug: slug,
            category: category,
            search: this.search
          }).then(function (response) {
            _this.feed = _this.feed.concat(response.data);
            _this.lastestResult = response.data.length;
            if (slug !== '') {
              _this.singlepost = response.data[0];
            }
          });
        }
      }
    },

    getPost: function getPost(slug) {
      var _this2 = this;

      this.loadPostReady = false;
      var url = 'http://haidangtravel.com/api/blog/' + slug;
      __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* axios */].post(url, {
        begin: this.feed.length,
        take: 1,
        slug: slug
      }).then(function (response) {
        _this2.singlepost = response.data[0] || {};
        _this2.loadPostReady = true;
      });
    },
    clearFeed: function clearFeed() {
      if (this.$route.name !== 'slug') {
        this.feed = [];
      }
    },
    setBegin: function setBegin(val) {
      this.begin = val;
    },
    setPostLoadState: function setPostLoadState(value) {
      this.postLoadState = value;
    },

    getDestinationpoints: function getDestinationpoints() {
      var _this3 = this;

      var url = 'http://haidangtravel.com/api/destinationpoint';
      __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* axios */].post(url).then(function (response) {
        _this3.destinationpoints = response.data;
      });
    }
  },
  data: function data() {
    return {
      navs: 0,
      title: '',
      labels: {
        post: '',
        author: '',
        search: '',
        category: ''
      },
      feed: [],
      begin: 0,
      website: '',
      singlepost: {},
      loadPostReady: false,
      lastestResult: 6,
      destinationpoints: []
    };
  },


  computed: {
    content: function content() {
      return { title: this.title, labels: this.labels, search: this.search };
    },
    filters: function filters() {
      var filters = {};
      // this.post = this.slug;
      if (this.slug) filters.post = this.slug;
      if (this.author) filters.author = this.author;
      if (this.category) filters.category = this.category;
      if (this.search) filters.search = this.search;

      return filters;
    }
  },

  watch: {
    '$route.name': function $routeName(to, from) {
      if (to !== from) {
        this.navs++;
        this.lastestResult = 6;
      }
      if (this.search !== '') {
        this.clearFeed();
      }
    },
    category: function category(to, from) {
      if (to !== from) {
        this.clearFeed();
        this.lastestResult = 6;
        this.loadFeed(null, 6);
      }
    },
    search: function search(to, from) {
      if (to !== from) {
        this.clearFeed();
        this.lastestResult = 6;
        // this.loadFeed(null, 6);
      }
    }
  },
  mounted: function mounted() {
    if (this.$route.name === 'index' || this.$route.name === 'feed') {
      this.clearFeed();
    }
    this.$getResource('blog').then(function (x) {});
    this.loadFeed(null, 6);
    // axios.get(`https://randomuser.me/api/?results=6`)
    //   .then(response => {
    //     this.feed = this.feed.concat(response.data.results);
    //   });
    this.getDestinationpoints();
  }
});

/***/ }),

/***/ "Dk1v":
/***/ (function(module, exports) {

module.exports = {"_args":[["scrollto-with-animation@4.5.2","F:\\Haidang2019\\VueBlog"]],"_from":"scrollto-with-animation@4.5.2","_id":"scrollto-with-animation@4.5.2","_inBundle":false,"_integrity":"sha1-WoS10aHtlDvlRiVULXcxk9bBGd4=","_location":"/scrollto-with-animation","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"scrollto-with-animation@4.5.2","name":"scrollto-with-animation","escapedName":"scrollto-with-animation","rawSpec":"4.5.2","saveSpec":null,"fetchSpec":"4.5.2"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/scrollto-with-animation/-/scrollto-with-animation-4.5.2.tgz","_spec":"4.5.2","_where":"F:\\Haidang2019\\VueBlog","author":{"name":"David Sancho","email":"dsnxmoreno@gmail.com","url":"https://github.com/davesnx"},"bugs":{"url":"https://github.com/davesnx/scrollto-with-animation/issues"},"dependencies":{"animation-frame":"^0.3.0"},"description":"Animated Scroll with requestAnimationFrame. For smooth animate scrollTo defining the easing, running at 60FPS and cross-browser","devDependencies":{"babel-cli":"^6.9.0","babel-loader":"^6.2.2","babel-preset-es2015":"^6.3.13","babel-preset-stage-2":"^6.3.13","jasmine-core":"^2.3.4","json-loader":"^0.5.4","karma":"^0.13.9","karma-chrome-launcher":"^0.2.1","karma-cli":"0.1.0","karma-coverage":"^0.5.3","karma-jasmine":"^0.3.6","karma-phantomjs-launcher":"^0.2.1","karma-sourcemap-loader":"^0.3.6","karma-spec-reporter":"0.0.22","karma-story-reporter":"^0.3.1","karma-webpack":"^1.7.0","phantomjs":"^1.9.18","pre-push":"^0.1.1","webpack":"^1.12.13"},"files":["src","lib","dist","README.md"],"homepage":"https://github.com/davesnx/scrollto-with-animation#readme","keywords":["animation","scrollTo","60fps","cross-browser","requestAnimationFrame","easeInQuad","browserify"],"license":"MIT","main":"lib/index.js","name":"scrollto-with-animation","pre-commit":["test"],"repository":{"type":"git","url":"git+https://github.com/davesnx/scrollto-with-animation.git"},"scripts":{"build":"npm run clean && npm run compile:prod && npm run minify:prod","clean":"rm -rf dist/* && rm -rf lib/","compile:dev":"NODE_ENV=dev babel src --watch --out-dir lib","compile:prod":"NODE_ENV=prod babel src --out-dir lib","minify:dev":"NODE_ENV=dev webpack --watch","minify:prod":"NODE_ENV=prod webpack -p","prepublish":"npm run build","test":"NODE_ENV=prod karma start test/karma.config.js --single-run","test:dev":"NODE_ENV=prod karma start test/karma.config.js --auto-watch"},"standard":{"parser":"babel-eslint","global":["jasmine","it","describe","beforeEach","afterEach","expect","spyOn"]},"version":"4.5.2"}

/***/ }),

/***/ "E7C/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueFacebookComment__ = __webpack_require__("KTQG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("cX0o");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-post',
  resource: 'BlogPost',
  components: { VueFacebookComment: __WEBPACK_IMPORTED_MODULE_0__VueFacebookComment__["a" /* default */] },
  props: {
    post: '',
    feed: {},
    postLoadState: false
  },

  data: function data() {
    return {
      title: '',
      author: '',
      content: '',
      published: '',
      description: '',
      categories: [],
      commentsReady: false,
      ready: false,
      url: ''
    };
  },


  computed: {
    allReady: function allReady() {
      return this.ready && this.post;
    }
  },

  watch: {
    '$route': function $route(to, from) {
      if (to !== from && to.name === 'slug') {
        this.getPost(this.post);
        this.url = window.location.href;
      }
    },
    post: function post(to, from) {
      // if (to === from || !this.post) return;
      // this.$emit('loadFeed', 1, this.post);
    },
    feed: function feed(to, from) {
      // console.log(to);
      // console.log(from);
      // if (to === from || !this.post) return;
      // this.commentsReady = false
      // this.$getResource('post', to)
      //   .then(this.showComments)
      //   .then(() => {
      //     this.ready = true;
      //   });
      // axios.post(`https://randomuser.me/api/`)
      //   .then(response => {
      //     this.title = response.data.results[0].name.first + ' ' + response.data.results[0].name.last;
      //     this.author = response.data.results[0].gender;
      //     this.published = response.data.results[0].registered.date;
      //     this.description = response.data.results[0].registered.date;
      //     this.content = 'Kiểm tra';
      //     this.showComments();
      //   }).then(() => {
      //     this.ready = true;
      //   });
      // console.log(to);
      // console.log(from);
      // this.$emit('loadfeed', 1, this.post)
      // console.log(this.feed[0]);
      // if (typeof this.feed[0] !== 'undefined') {
      this.initPost(this.feed);
      this.$emit('setPostLoadState', false);
      // }
    }
  },

  methods: {
    kebabify: __WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* kebabify */],
    prettyDate: __WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* prettyDate */],
    showComments: function showComments() {
      var _this = this;

      // This is injected by prerender-spa-plugin on build time, we don't prerender disqus comments.
      if (window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.prerendered) {
        return;
      }
      setTimeout(function () {
        _this.commentsReady = true;
      }, 1000);
    },
    initPost: function initPost(post) {
      this.showComments();
      this.title = post.title;
      this.published = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* prettyDate */])(post.created_at);
      this.description = post.description;
      this.content = post.content;
      this.categories = post.subjectblogs;
      this.ready = true;
    },
    getPost: function getPost(slug) {
      if (typeof slug !== 'undefined') {
        this.$emit('getPost', slug);
      }
    }
  },
  created: function created() {
    // this.getPost(this.post);
    this.url = window.location.href;
  },
  mounted: function mounted() {
    if (!this.post) {
      this.ready = true;
      return;
    }
    this.ready = true;
    if (this.slug !== '') {
      this.getPost(this.post);
    }
    // console.log(this.post);
    // this.showComments();
    // this.$getResource('post', this.post)
    //   .then(this.showComments)
    //   .then(() => {
    //     this.ready = true;
    //   });
    // console.log(this.$props.feed);
  },
  beforeUpdate: function beforeUpdate() {
    // console.log(this.feed);
  },
  updated: function updated() {
    // console.log(this.feed);
    // if (this.postLoadState) {
    //   this.getPost(this.post);
    // }
    // this.getPost(this.post);
  }
});

/***/ }),

/***/ "InHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__ = __webpack_require__("E7C/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bce351e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__ = __webpack_require__("lr5C");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bce351e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KTQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueFacebookComment_vue__ = __webpack_require__("p/K+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fc76de2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueFacebookComment_vue__ = __webpack_require__("xm51");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueFacebookComment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fc76de2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueFacebookComment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LEUU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},[_c('h1',{staticClass:"nav__title"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.content.title))])],1),_vm._v(" "),_c('div',{staticClass:"search-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],attrs:{"type":"text","placeholder":"Search..","name":"Tìm kiếm"},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.navSearch($event)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":_vm.navSearch}},[_c('font-awesome-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"nav__menu",attrs:{"tag":"menu","name":"nav__item"}},_vm._l((_vm.labels),function(label){return _c('li',{key:label,staticClass:"nav__item",on:{"click":_vm.navBack}},[_c('i',{staticClass:"nav__item--icon"}),_vm._v(" "),_c('span',{staticClass:"nav__item--label"},[_vm._v(_vm._s(label))])])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_118f84a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("bNcV");
function injectStyle (ssrContext) {
  __webpack_require__("iby1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_118f84a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MdQY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return matchMedia; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);


var matchMediaFallback = function matchMediaFallback() {
  var listeners = [];
  var idle = true;

  var device = function () {
    var node = document.createElement('div');
    var style = document.createElement('style');

    node.id = 'match-media-node';
    style.innerHTML = '#match-media-node {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      bottom: 100%;\n      overflow: scroll;\n    }';

    document.head.appendChild(style);
    document.body.insertBefore(node, document.body.children[0]);

    return {
      get width() {
        return node.clientWidth;
      },
      get height() {
        return node.clientHeight;
      },
      get orientation() {
        return node.clientHeight > node.clientWidth ? 'portrait' : 'landscape';
      },
      get fontSize() {
        return window.getComputedStyle(document.documentElement).getPropertyValue('font-size');
      }
    };
  }();

  var createHandler = function createHandler(feature, value) {
    if (feature === 'orientation') {
      return function () {
        return value === device.orientation;
      };
    }

    var _feature$split$revers = feature.split('-').reverse(),
        _feature$split$revers2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_feature$split$revers, 2),
        prop = _feature$split$revers2[0],
        limit = _feature$split$revers2[1];

    var operand = !limit ? '==' : limit === 'min' ? '<' : '>';

    var parseValue = function () {
      return ~value.indexOf('em') ? function () {
        return parseFloat(value) * device.fontSize;
      } : function () {
        return parseFloat(value);
      };
    }();

    var handlers = {
      'width': function width() {
        return eval(parseValue() + operand + device.width);
      },
      'height': function height() {
        return eval(parseValue() + operand + device.height);
      }
    };

    return handlers[prop];
  };

  var parseQuery = function parseQuery(queryString) {
    var _queryString$replace$ = queryString.replace(/[()\s]/g, '').split(':'),
        _queryString$replace$2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_queryString$replace$, 2),
        feature = _queryString$replace$2[0],
        value = _queryString$replace$2[1];

    return createHandler(feature, value);
  };

  window.addEventListener('resize', function () {
    if (!idle) return;
    idle = false;

    var width = device.width;
    var height = device.height;

    var timer = setInterval(function () {
      if (width !== device.width || height !== device.height) {
        width = device.width;
        height = device.height;
      } else {
        clearTimeout(timer);
        listeners.forEach(function (handler) {
          return handler();
        });
        idle = true;
      }
    }, 100);
  });

  return function (queryString) {
    var query = parseQuery(queryString);
    var matcher = {
      get matches() {
        return query();
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, matcher, {
      addListener: function addListener(cb) {
        var handler = function handler() {
          return cb(matcher);
        };
        listeners.push(handler);
      }
    });
  };
};

var matchMedia = window.matchMedia || matchMediaFallback();



/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources__ = __webpack_require__("9k9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_resource__ = __webpack_require__("cb2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_device_queries__ = __webpack_require__("uJQI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pace_progress__ = __webpack_require__("heTW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pace_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pace_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vueinview__ = __webpack_require__("am+L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vueinview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vueinview__);














__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["e" /* faSearch */]);
__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["a" /* faCoffee */]);
__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["c" /* faMapMarker */]);
__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["d" /* faPhone */]);
__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["b" /* faMailBulk */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_11__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vueinview___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__plugins_resource__["a" /* default */], {
  resources: __WEBPACK_IMPORTED_MODULE_5__resources__,
  endpoint: '/static/api'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__plugins_device_queries__["a" /* default */], {
  phone: 'max-width: 567px',
  tablet: 'min-width: 568px',
  mobile: 'max-width: 1024px',
  laptop: 'min-width: 1025px',
  desktop: 'min-width: 1280px',
  monitor: 'min-width: 1448px'
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]);
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_8_pace_progress___default.a.start();
    __WEBPACK_IMPORTED_MODULE_8_pace_progress___default.a.on('hide', function () {
      document.dispatchEvent(new Event('app.rendered'));
    });
  }
}).$mount('#app');

/***/ }),

/***/ "SGec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__ = __webpack_require__("CHQz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72d829e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__ = __webpack_require__("TZii");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72d829e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TZii":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"blog",class:{ 'blog--reading': this.post }},[_c('blog-nav',{attrs:{"content":_vm.content,"filters":_vm.filters,"navs":_vm.navs,"search":_vm.search},on:{"clearFeed":_vm.clearFeed}}),_vm._v(" "),_c('blog-feed',{attrs:{"filters":_vm.filters,"feed":_vm.feed,"website":_vm.website}}),_vm._v(" "),_c('blog-post',{attrs:{"postLoadState":_vm.loadPostReady,"post":_vm.slug,"feed":_vm.singlepost},on:{"getPost":_vm.getPost,"setPostLoadState":_vm.setPostLoadState}}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_vm._v(" ")]),_vm._v(" "),((!_vm.post) && _vm.feed.length > 0)?_c('blog-footer',{directives:[{name:"inview",rawName:"v-inview:enter",value:(_vm.loadFeed),expression:"loadFeed",arg:"enter"}],attrs:{"filters":_vm.filters,"destinationpoints":_vm.destinationpoints}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WYec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var store = {};

  return {
    has: function has(uri) {
      return !!store[uri];
    },
    get: function get(uri) {
      return JSON.parse(store[uri]);
    },
    set: function set(uri, data) {
      store[uri] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
    }
  };
})());

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("bGai");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: '/blog',
    name: 'feed',
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: '/search/:search',
    name: 'search',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: '/blog/category/:category',
    name: 'category',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: '/blog/category/:slug/search/:search',
    name: 'category_search',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: '/blog/:slug',
    name: 'slug',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }]
}));

/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Blog__ = __webpack_require__("SGec");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Blog__["a"]; });


/***/ }),

/***/ "bNcV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"id":"app"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bksL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  feed: function feed() {
    return {
      path: '/feed.json',
      resolve: function resolve(response, mappers) {
        return mappers.pipe(response.results);
      }
    };
  }
});

/***/ }),

/***/ "cX0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return scrollTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return kebabify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return prettyDate; });
/* unused harmony export dateToString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return axios; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation__ = __webpack_require__("M75F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation__);



var scrollTo = function scrollTo(pos) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation___default()(document.documentElement, 'scrollTop', pos, duration, 'easeInOutSine', resolve);
    }, delay);
  });
};
var kebabify = function kebabify(words) {
  return words.toLowerCase().replace(' ', '-');
};

var prettyDate = function prettyDate(date) {
  // return date;
  var rtn = new Date(date.replace(/\s/, 'T'));
  // let rtn = new Date(date).toString().split(' ').slice(0, 4).join(' ').replace(/( \d+)$/, ',$1')
  return dateToString(rtn);
};
var dateToString = function dateToString(date) {
  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var day = date.getDate();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();
  if (day < 10) day = '0' + day.toString();
  if (month < 10) month = '0' + month.toString();
  if (type === 1) {
    return day.toString() + char + month.toString() + char + year.toString();
  } else {
    return year.toString() + char + month.toString() + char + day.toString();
  }
};
var axios = __webpack_require__("mtWM");

/***/ }),

/***/ "cb2V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cache__ = __webpack_require__("WYec");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge__ = __webpack_require__("mB6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_merge__);





// install $resource as a Vue plugin
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, _ref) {
    var _ref$endpoint = _ref.endpoint,
        endpoint = _ref$endpoint === undefined ? '' : _ref$endpoint,
        _ref$resources = _ref.resources,
        resources = _ref$resources === undefined ? {} : _ref$resources;

    Vue.prototype.$getResource = function (method, options) {
      var _this = this;

      var name = this.$options.resource;
      if (!name || !resources[name] || !resources[name][method]) return;
      // get fetch path and response resolver/mapper

      var _resources$name$metho = resources[name][method](options),
          path = _resources$name$metho.path,
          resolve = _resources$name$metho.resolve;

      var uri = endpoint + path;

      // methods return promise to allow chaining
      var mappers = {
        // only return promise without modifying instance $data
        pipe: function pipe(dataSet) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(dataSet);
        },

        // deep merge object with instance $data
        merge: function merge(dataSet) {
          __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default()(_this.$data, dataSet);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(dataSet);
        },

        // set individual props on instance $data
        set: function set(dataSet) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataSet).forEach(function (prop) {
            _this.$set(_this.$data, prop, dataSet[prop]);
          });

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(dataSet);
        }

        // check to see if the resource has been cached already
      };if (__WEBPACK_IMPORTED_MODULE_2__cache__["a" /* default */].has(uri)) return resolve(__WEBPACK_IMPORTED_MODULE_2__cache__["a" /* default */].get(uri), mappers);

      // fetch, parse and cache resource then pass to resolver
      return fetch(uri).then(function (response) {
        return response.json();
      }).then(function (response) {
        return __WEBPACK_IMPORTED_MODULE_2__cache__["a" /* default */].set(uri, response);
      }).then(function (response) {
        return resolve(response, mappers);
      });
    };
  }
});

/***/ }),

/***/ "eJ85":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  blog: function blog() {
    return {
      path: '/blog.json',
      resolve: function resolve(response, mappers) {
        var blog = response.results[0];
        return mappers.merge({
          title: blog.title,
          labels: {
            post: blog.post_label,
            author: blog.author_label,
            search: blog.search_label
          },
          website: blog.website
        });
      }
    };
  }
});

/***/ }),

/***/ "ggVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("cX0o");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-nav',
  data: function data() {
    return {
      search_input: this.$props.search || ''
    };
  },

  props: {
    navs: Number,
    content: Object,
    filters: {
      type: Object,
      default: function _default() {}
    },
    search: String
  },
  computed: {
    labels: function labels() {
      var _this = this;

      var filterLabels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).map(function (filter) {
        return _this.content.labels[filter];
      });
      if (this.$route.name === 'category') {
        filterLabels = [this.filters.category];
      }
      return filterLabels;
    }
  },

  methods: {
    kebabify: __WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* kebabify */],
    navBack: function navBack() {
      this.search_input = '';
      // if (this.navs && !this.filters.author) {
      //   if (this.$router.name === 'slug') {
      //     this.$emit('clearFeed');
      //   }
      //   this.$router.go(-1);
      // } else {
      //   this.$router.push('/')
      // }
      this.$router.push('/');
    },
    navSearch: function navSearch() {
      if (this.search_input !== '') {
        this.$router.push('/search/' + Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* kebabify */])(this.search_input));
      }
    }
  },
  watch: {
    search: function search(val) {
      this.search_input = val;
    }
  }
});

/***/ }),

/***/ "iby1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kYEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFooter_vue__ = __webpack_require__("6Lyb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0085cab4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFooter_vue__ = __webpack_require__("vwmM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0085cab4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lr5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"post"}},[(_vm.allReady)?_c('article',{staticClass:"post"},[_c('header',{staticClass:"post__header"},[_c('h2',{staticClass:"post__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h3',{staticClass:"post__meta"},[_vm._l((_vm.categories),function(category,index){return _c('router-link',{key:category.id,staticClass:"post__author",attrs:{"to":("/blog/category/" + (category.slug))}},[_vm._v(_vm._s(category.title)+" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(index<(_vm.categories.length-1)),expression:"index<(categories.length-1)"}]},[_vm._v("|")])])}),_vm._v(" "),_c('span',{staticClass:"post__sep"}),_vm._v(" "),_c('time',[_vm._v(_vm._s((_vm.published))+" "+_vm._s(_vm.post.subjectblogs))])],2),_vm._v(" "),_c('blockquote',{staticClass:"post__subtitle",domProps:{"innerHTML":_vm._s(_vm.description)}})]),_vm._v(" "),_c('section',{staticClass:"post__body rte",domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('footer',{staticClass:"post__footer"},[(_vm.commentsReady)?_c('vue-facebook-comment',{attrs:{"url":_vm.url}}):_vm._e()],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p/K+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-facebook-comment',
  props: {
    url: String
  },
  created: function created() {
    (function (d, s, id) {
      var js;
      var fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.crossorigin = 'anonymous';
      js.src = '//connect.facebook.net/vi_VN/sdk.js#xfbml=1&version=v3.2&appId=547213038750090&autoLogAppEvents=1';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
    window.fbAsyncInit = function onSDKInit() {
      window.FB.XFBML.parse();
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      if (typeof window.FB !== 'undefined') {
        window.FB.XFBML.parse();
      }
    });
  },
  updated: function updated() {},
  watch: {
    url: function url(to, from) {
      if (to !== from) {
        if (typeof window.FB !== 'undefined') {
          window.FB.XFBML.parse();
        }
      }
    }
  }
});

/***/ }),

/***/ "r1rV":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "rcwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(id) {
    return {
      path: '/post/' + id + '.json',
      resolve: function resolve(response, mappers) {
        var _response$results$ = response.results[0],
            title = _response$results$.title,
            content = _response$results$.content,
            meta = _response$results$.meta;

        content = '<p>' + content.split('\n\n').join('</p><p>') + '</p>';
        return mappers.merge(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ title: title, content: content }, meta));
      }
    };
  }
});

/***/ }),

/***/ "uJQI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_media__ = __webpack_require__("MdQY");



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, queries) {
    var DeviceVM = new Vue({
      data: function data() {
        return {
          devices: {}
        };
      },


      methods: {
        addDevice: function addDevice(name, active) {
          var _this = this;

          this.$set(this.devices, name, active);

          return function (_ref) {
            var matches = _ref.matches;

            _this.devices[name] = matches;
          };
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(queries).forEach(function (name) {
      var query = Object(__WEBPACK_IMPORTED_MODULE_1__match_media__["a" /* default */])('(' + queries[name] + ')');
      var update = DeviceVM.addDevice(name, query.matches);
      query.addListener(update);
    });

    Vue.prototype.$device = DeviceVM.devices;
  }
});

/***/ }),

/***/ "vwmM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"v--mask"}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"blog__footer"},[_c('b-container',[_c('div',{staticClass:"clearfix"},[_vm._v(" ")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"footer__logo",attrs:{"lg":"6","sm":"12"}},[_c('a',{staticClass:"signature",attrs:{"href":"http://haidangtravel.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("r1rV")}})])]),_vm._v(" "),(!_vm.reading || _vm.$device.phone)?_c('b-col',{staticClass:"footer__address text-center",attrs:{"lg":"6","sm":"12"}},[_c('div',{staticClass:"info-list "},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"map-marker"}}),_vm._v(" "),_c('span',[_vm._v("367 Tân Sơn, Phường 15, Quận Tân Bình, Hồ Chí Minh")])],1),_vm._v(" "),_c('div',[_c('font-awesome-icon',{attrs:{"icon":"phone"}}),_vm._v(" "),_c('span',[_vm._v("19002011 - 0948991080")])],1),_vm._v(" "),_c('div',[_c('font-awesome-icon',{attrs:{"icon":"mail-bulk"}}),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"mailto:info@haidangtravel.com"}},[_c('span',[_vm._v("info@haidangtravel.com")])])],1)])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_vm._v(" ")]),_vm._v(" "),(!_vm.reading || _vm.$device.phone)?_c('b-row',_vm._l((_vm.destinationpoints),function(dp){return _c('b-col',{key:dp.slug,attrs:{"lg":"3","sm":"12"}},[_c('a',{staticClass:"link",attrs:{"href":'http://haidangtravel.com/diem-den/'+dp.slug}},[_vm._v("\n            Tour "+_vm._s(dp.title)+"\n          ")])])}),1):_vm._e()],1)],1)}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({ name: 'app' });

/***/ }),

/***/ "xdpD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFeed_vue__ = __webpack_require__("2x06");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16153447_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFeed_vue__ = __webpack_require__("xj9u");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16153447_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xj9u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"blog__feed",attrs:{"tag":"ul","name":_vm.transition}},_vm._l((_vm.feed_filter),function(post,index){return _c('li',{key:post.id,staticClass:"preview"},[_c('figure',{staticClass:"preview__figure",class:_vm.figureClass,style:(_vm.getBgImg(post.images))},[_c('transition',{attrs:{"name":"v--fade"}},[(!_vm.reading || _vm.$device.phone)?_c('figcaption',{staticClass:"preview__details"},[_c('router-link',{staticClass:"preview__title",attrs:{"to":("/blog/" + (post.slug))},nativeOn:{"click":function($event){return _vm.scrollTo(0, 220, _vm.scrollDelay)}}},[_vm._v("\n            "+_vm._s(post.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"preview__meta"},[_c('time',{staticClass:"preview__published"},[_vm._v("\n              "+_vm._s(_vm.prettyDate(post.created_at))+"\n            ")]),_vm._v(" "),_vm._l((post.subjectblogs),function(category,index){return _c('router-link',{key:category.id,staticClass:"preview__author",attrs:{"to":("/blog/category/" + (_vm.kebabify(category.slug)))},nativeOn:{"click":function($event){return _vm.scrollTo(0, 220, _vm.scrollDelay)}}},[_vm._v("\n              "+_vm._s(category.title)+" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(index<(post.subjectblogs.length-1)),expression:"index<(post.subjectblogs.length-1)"}]},[_vm._v("|")])])})],2)],1):_vm._e()])],1)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xm51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"comment"}},[_c('div',{staticClass:"fb-comments",attrs:{"data-href":_vm.url,"data-numposts":"5"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y7Eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogNav_vue__ = __webpack_require__("ggVv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7efd008e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogNav_vue__ = __webpack_require__("LEUU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7efd008e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.58bfe67918b67b5b6736.js